
import { Component, Prop, Vue } from 'vue-property-decorator'
import KAMReadOnlyForm from '@/views/kam/forms/KAMReadOnlyForm.vue'
import { booleanLabel, dateLabel, listLabels, personLabel, ReadOnlySection, valueOrDash } from '@/views/kam/forms/kamReadOnlyPresenter'

@Component({
  components: { 'kam-read-only-form': KAMReadOnlyForm }
})
export default class KAM002V2 extends Vue {
  @Prop({ required: true }) answers!: Record<string, any>
  @Prop({ default: () => ({}) }) media!: Record<string, any>
  @Prop({ default: () => [] }) siteManagers!: any[]
  @Prop({ default: () => [] }) projectLeaders!: any[]
  @Prop({ default: () => [] }) constructionWorkers!: any[]
  @Prop({ default: () => [] }) employees!: any[]

  get phaseLabels () : string[] {
    const labels: Record<string, string> = {
      ground: 'Grond',
      foundation: 'Fundering',
      shell: 'Ruwbouw',
      finish: 'Afbouw'
    }
    return listLabels(this.answers?.workPhases).map(value => labels[value] || value)
  }

  get sections () : ReadOnlySection[] {
    const answers = this.answers || {}
    return [
      {
        key: 'bedrijf',
        title: 'Bedrijfsgegevens o.a.',
        fields: [
          { key: 'companyName', label: 'Naam', value: valueOrDash(answers.companyName) },
          { key: 'companyAddress', label: 'Adres', value: valueOrDash(answers.companyAddress) },
          { key: 'companyCity', label: 'Plaats', value: valueOrDash(answers.companyCity) }
        ]
      },
      {
        key: 'project',
        title: 'Project en werkzaamheden',
        fields: [
          { key: 'projectName', label: 'Projectnaam', value: valueOrDash(answers.projectName) },
          { key: 'projectReference', label: 'Projectnummer', value: valueOrDash(answers.projectReference) },
          { key: 'projectAddress', label: 'Projectadres', value: valueOrDash(answers.projectAddress) },
          { key: 'projectCity', label: 'Projectplaats', value: valueOrDash(answers.projectCity) },
          { key: 'workPhases', label: 'Fase', kind: 'array', value: this.phaseLabels },
          { key: 'remarks', label: 'Opmerkingen', value: valueOrDash(answers.remarks) }
        ]
      },
      {
        key: 'verantwoordelijken',
        title: 'Verantwoordelijken',
        fields: [
          { key: 'finalResponsibleName', label: 'Eindverantwoordelijke', value: valueOrDash(answers.finalResponsibleName) },
          { key: 'finalResponsiblePhone', label: 'Mobiel tel. eindverantwoordelijke', value: valueOrDash(answers.finalResponsiblePhone) },
          { key: 'onSiteResponsibleName', label: 'Aanwezig op het werk', value: valueOrDash(answers.onSiteResponsibleName || personLabel(answers.onSiteResponsibleId, this.siteManagers)) },
          { key: 'onSiteResponsiblePhone', label: 'Mobiel tel. aanwezig op het werk', value: valueOrDash(answers.onSiteResponsiblePhone) },
          { key: 'planDiscussedWith', label: 'VGM-plan doorgesproken met', value: valueOrDash(answers.planDiscussedWith) },
          { key: 'vgCoordinatorName', label: 'VGM-coördinator uitvoeringsfase', value: valueOrDash(answers.vgCoordinatorName || personLabel(answers.vgCoordinatorId, this.employees)) },
          { key: 'planDate', label: 'Datum', value: dateLabel(answers.planDate) }
        ]
      },
      {
        key: 'tabellen',
        title: 'Onderaannemers en risico’s',
        tables: [
          {
            key: 'subcontractors',
            label: 'Onderaannemers die u inschakelt op dit project',
            rows: Array.isArray(answers.subcontractors) ? answers.subcontractors : [],
            columns: [
              { key: 'name', label: 'Onderaannemer' },
              { key: 'work', label: 'Uit te voeren werkzaamheden' },
              { key: 'responsible', label: '1e verantwoordelijke' }
            ]
          },
          {
            key: 'risks',
            label: 'Risico’s en maatregelen',
            rows: Array.isArray(answers.risks) ? answers.risks : [],
            columns: [
              { key: 'risk', label: 'Risico' },
              { key: 'measures', label: 'Maatregelen' },
              { key: 'supplyBy', label: 'Leveren / aanbrengen door' },
              { key: 'maintainBy', label: 'In stand houden door' }
            ]
          }
        ]
      },
      {
        key: 'akkoord',
        title: 'Akkoord',
        fields: [
          { key: 'signatureName', label: 'Naam ondertekenaar', value: valueOrDash(answers.signatureName) },
          { key: 'signatureDate', label: 'Datum ondertekening', value: dateLabel(answers.signatureDate) },
          { key: 'signature', label: 'Handtekening', kind: 'array', value: listLabels(answers.signature) },
          { key: 'hasSignature', label: 'Handtekening aanwezig', value: booleanLabel(Boolean(answers.media?.signature || answers.signature?.length)) }
        ]
      }
    ]
  }
}
